<template>
  <section class="section">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("trip module settings") }}
      </h1>
    </div>

    <!-- <div class="box mt-0">
      <div class="columns">
        <div class="column is-5">
          <h1 class="title is-4">{{ $t("profiles") }}</h1>
        </div>
        <div class="column is-7">
          <p class="buttons is-pulled-right">
            <button class="button is-secondary is-rounded" @click="create">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>{{ $t("add") }}</span>
            </button>            
          </p>
        </div>
      </div>
      <div class="table-container" ref="tc">
        <table
          class="table is-striped is-hoverable"
          ref="table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(profile, pidx) in meta.profiles" :key="pidx">
              <td>{{ profile.name }}</td>              
              <td>
                <p class="buttons">
                  <a
                    class="button"
                    :data-tooltip="$t('configure')"
                    @click="configure_profile(profile)"
                  >
                    <span class="icon has-text-info">
                      <i class="fa fa-cogs"></i>
                    </span>
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>
    </div> -->

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- <profile-modal ref="profile_modal" @success="profile_modified" /> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";
import { isEmpty } from "lodash";
import { v4 } from "uuid";
// import ProfileModal from "./profile_modal/Index.vue";

export default {
  name: "VisanetPaymentSettings",
  components: {},
  data() {
    return {
      meta: {
        // profiles: [],
      },
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    // create() {
    //   let v = this;
    //   v.meta.profiles.push({ uuid: v4(), name: v.$t("new profile") });
    // },
    // configure_profile(profile) {
    //   let v = this;
    //   v.$refs.profile_modal.show_modal(profile);
    // },
    // profile_modified(profile) {
    //   let v = this;
    //   let trgt = v.meta.profiles.find((p) => p.uuid === profile.uuid);
    //   if (trgt) {
    //     Object.keys(profile).map((k) => {
    //       trgt[k] = profile[k];
    //     });
    //   }
    // },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
